//core
import React, { Component } from 'react';
//material-ui
import withStyles from "@material-ui/core/styles/withStyles"
import FormLabel from "@material-ui/core/FormLabel";
//dashboard-pro
import Card from "components/Card/Card.jsx"
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx"
import NavPills from 'components/defaultNavPills/NavPills.jsx'
import CustomInput from "components/CustomInput/CustomInput.jsx";
//bussiness
import CompanyCertificationsTable from 'global/CompanyCertificationsTable'
import CompanysendareaModal from 'global/CompanysendareaModal'
//css
import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";



class Certificate extends Component {
    constructor(props){
        super(props);
        this.state = {
            supplierClass:{
                id:'',name:''
            }
        }
        this.valueChange = this.valueChange.bind(this);
        this.selectConfirm = this.selectConfirm.bind(this);
    }

    componentDidMount(){
        // console.log('加载');
    }

    enterStep(){
        console.log('我进来了');
    }

    uploadSuccess(row,url){
        this.props.changeFun(row,url);
    }

    valueChange(id,name){
        //变更之后，等保存后再请求船新的证书列表
        //即放在selectConfirm方法中
        this.setState({
            supplierClass:{id:id,name:name}
        })
        // this.props.getCertificate();
    }

    selectConfirm(supplyClassId){
        //机械设备属于物资材料，先把文字替换掉
        // let regStr = /机械设备/i;
        // let nameStr = this.state.supplierClass.name.replace('机械设备','物资材料');
        let nameStr = this.state.supplierClass.name.replace(/机械设备(?!安)(?!租)/i,'物资材料');
        //字符串转换为数组
        let nameArr = nameStr.split(',');
        let resultArr = [];
        nameArr.forEach(element => {
            for (const key in supplyClassId) {
                if (supplyClassId.hasOwnProperty(key)) {
                    if (element === supplyClassId[key]) {
                        resultArr.push(key);
                    }
                }
            }
        });
        this.props.getCertificate(resultArr.join(','),this.state.supplierClass.id);
    }

    render() {
        const {classes} = this.props;
        let tabs = (this.props.formObj.cartoryInfos && this.props.formObj.cartoryInfos.length > 0) ? (
            this.props.formObj.cartoryInfos.map((prop,index) => {
                return {
                    tabButton:prop.name,
                    tabContent:(
                        <CompanyCertificationsTable
                            index={index}
                            openSnackbar={this.props.openSnackbar}
                            closeSnackbar={this.props.closeSnackbar}
                            uploadSuccess={this.props.changeFun}
                            tableData={prop.gategories}/>
                    )
                }
            })
        ) : [];
        return (
            <Card style={{marginTop:"10px",marginBottom:"10px"}}>
                <CardHeader>
                    <GridContainer>
                        <GridItem xs={4} sm={4} md={3}>
                            <FormLabel className={classes.labelHorizontal}>
                                <span className={classes.validationSymbol}>*</span>请选择供货类别
                            </FormLabel>
                        </GridItem>
                        <GridItem xs={8} sm={8} md={4}>
                            <CustomInput formControlProps={{fullWidth: true}} id='supplierClass'
                                inputProps={{className:'long-input',disabled: true,value:(this.state.supplierClass.name)}}/>
                        </GridItem>
                        <GridItem xs={8} sm={8} md={2}>
                            <CompanysendareaModal type='supplierClass' selectTree={this.valueChange}
                                selectedNodeText={this.state.supplierClass.name} selectConfirm={this.selectConfirm}
                                selectedNode={this.state.supplierClass.id} openSnackbar={this.props.openSnackbar}/>
                        </GridItem>
                    </GridContainer>
                    <GridContainer>
                    <GridItem xs={4} sm={4} md={3}></GridItem>
                    <GridItem xs={8} sm={8} md={9}>
                        <span className={classes.validationSymbol}>一旦更改供货类别，所有证书需重新上传</span>
                    </GridItem>
                </GridContainer>
                </CardHeader>
                <CardBody>
                    <NavPills color="info" horizontal={{
                        tabsGrid:{xs:5,sm:5,md:3},
                        contentGrid:{xs:7,sm:7,md:9}
                    }}
                    tabs={tabs}
                    />
                </CardBody>
            </Card>
        )
    }
}

export default withStyles(regularFormsStyle)(Certificate);
